import React, { useEffect, useState } from "react";
import { Col, Button, Row } from "reactstrap";
import { Colors,
    OutputRow,
    BoldLabel,
    LeftLabel,
    HighlightedCost,
    TableTitle,
    WhiteTableContainer,
    UnderlineButton,} from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";

import AccommodationRow from "../../experiences/cost-summary/exp-accommodation-row";
import FlightRow from "../../experiences/cost-summary/exp-flight-row";
import ActivityRow from "../../experiences/cost-summary/exp-activity-row";
import TransportationRow from "../../experiences/cost-summary/exp-transportation-row";
import MealsRow from "../../experiences/cost-summary/exp-meals-row";
import MiscellaneousRow from "../../experiences/cost-summary/exp-miscellaneous-row";
import RebelFinalCostRow from './rebel-final-cost-row';
import RebelContingencyRow from "./rebel-contingency-row";
import { displayValue } from "../../helper";
import { calculateSubCostPerAttendee,
    calculateTotalCostPerAttendee,
    calculateCostTrip,
    calculateSubCostNoFlightsPerAttendee,
    calculateCostPerAttendee,
    calculateCostAccommodation,
    calculateCostFlight,
    calculateCostActivity,
    calculateCostGroundTransport,
    calculateCostMeals,
    calculateCostMeetings,
    calculateCostMiscellaneous, } from "../../experiences/cost-summary/cost-helper";
import MeetingsRow from "../../experiences/cost-summary/exp-meetings.row";
import styled from "styled-components";

const CostOutput = ({guideData, expData, clientCurrency, currencyConversionRatio}) => {
    // Console log all the calculation values for REBEL experiences
    console.log('=== REBEL COST BREAKDOWN ===');
    console.log('Guide Data:', guideData);
    console.log('Experience Data:', expData);
    console.log('Trip Length:', guideData.tripLength?.value);
    console.log('Attendees:', guideData.attendees?.value);
    console.log('Number of Breakfasts:', guideData.numBreakfast?.value);
    console.log('Number of Lunches:', guideData.numLunch?.value);
    console.log('Number of Dinners:', guideData.numDinner?.value);
    console.log('Number of Drinks:', guideData.numAlcohol?.value);
    console.log('calculateCostTrip result:', calculateCostTrip(guideData, expData));
    console.log('Per Attendee Cost:', calculateCostTrip(guideData,expData) / guideData.attendees.value);
    console.log('=== END REBEL COST BREAKDOWN ===');

    return (
        <React.Fragment>
            <RebelLeftLabel>Per Attendee Cost: </RebelLeftLabel> <RebelHighlightedCost>{guideData.currency.value} {displayValue(calculateCostTrip(guideData,expData) / guideData.attendees.value)}</RebelHighlightedCost> <br/>
            <RebelLeftLabel>Total Program Cost: </RebelLeftLabel> <RebelHighlightedCost>{guideData.currency.value} {displayValue(calculateCostTrip(guideData, expData))}</RebelHighlightedCost> <br/> <br/>

            <RebelTableTitle>
                Trip Breakdown
            </RebelTableTitle>
            <RebelTableContainer id="output-form-container">
                <RebelOutputRow>
                    <Col lg="1">
                    </Col>
                    <Col>
                        <RebelBoldLabel>
                            Category
                        </RebelBoldLabel>
                    </Col>
                    <Col lg="2">
                        <RebelBoldLabel>
                            Per Attendee ({guideData.currency.value})
                        </RebelBoldLabel>
                    </Col>
                    <Col lg="1"></Col>
                    <Col lg="2">
                        <RebelBoldLabel>
                            Subtotal ({guideData.currency.value})
                        </RebelBoldLabel>
                    </Col>
                </RebelOutputRow>

                {calculateCostAccommodation(guideData, expData) > 0 && <AccommodationRow guideData={guideData} expData={expData}/>}
                {calculateCostFlight(guideData, expData) > 0 && <FlightRow guideData={guideData} expData={expData}/>}
                {calculateCostActivity(guideData, expData) > 0 && <ActivityRow guideData={guideData} expData={expData}/>}
                {calculateCostGroundTransport(guideData, expData) > 0 && <TransportationRow guideData={guideData} expData={expData}/>}
                {calculateCostMeals(guideData, expData) > 0 && <MealsRow guideData={guideData} expData={expData}/>}
                {calculateCostMeetings(guideData, expData) > 0 && <MeetingsRow guideData={guideData} expData={expData}/>}
                {calculateCostMiscellaneous(guideData, expData) > 0 && <MiscellaneousRow guideData={guideData} expData={expData}/>}
                <RebelContingencyRow guideData={guideData} expData={expData}/>
                <RebelFinalCostRow currencyConversionRatio={currencyConversionRatio} clientCurrency={clientCurrency} guideData={guideData} expData={expData} villaId={expData.villaId?.value}/>

                </RebelTableContainer>
            </React.Fragment>
    )
}

export default CostOutput;

const RebelLeftLabel = styled(LeftLabel)`
    color: ${RebelColors.primary};
`

const RebelHighlightedCost = styled(HighlightedCost)`
    color: ${RebelColors.gold};
`

const RebelTableTitle = styled(TableTitle)`
    color: ${RebelColors.gold};
    border-bottom: none;
`

const RebelTableContainer = styled(WhiteTableContainer)`
    background-color: ${RebelColors.surface};
    border: 1px solid ${RebelColors.border};

    p {
        color: ${RebelColors.primary};
    }

    span {
        color: ${RebelColors.primary};
    }

    /* Style the "x {attendees}" text to white */
    > div > div {
        color: ${RebelColors.primary};
    }

    /* Override all top-level OutputRow borders to be light gray instead of white */
    > .row {
        border-bottom: 1px solid #444444 !important;
    }

    /* Remove borders from nested rows inside category rows (title row) */
    > .row .row {
        border-bottom: none !important;
    }

    /* Ensure rows with explicit border-bottom: none stay that way */
    > .row[style*="border-bottom: none"] {
        border-bottom: none !important;
    }

    /* Override CollapseRow borders in expanded sections to be light gray */
    > div > .row {
        border-bottom: 1px solid #444444 !important;
    }

    /* Style the collapse button icons to gold */
    svg {
        color: ${RebelColors.gold};
    }

    /* Style the table icons to gold */
    .fa-bed, .fa-plane, .fa-running, .fa-car, .fa-utensils,
    .fa-briefcase, .fa-plus-circle, .fa-percentage {
        color: ${RebelColors.gold};
    }

    /* Override the yellow/gold collapse card backgrounds with REBEL surface color */
    .card {
        background-color: ${RebelColors.surfaceLight} !important;
        border: 1px solid ${RebelColors.border};
    }

    /* Ensure text in collapsed sections is white */
    .card-body {
        color: ${RebelColors.primary};
    }

    .card-body p,
    .card-body span {
        color: ${RebelColors.primary};
    }
`

const RebelOutputRow = styled(OutputRow)`
    border-bottom: 2px solid white !important;
`

const RebelBoldLabel = styled(BoldLabel)`
    color: ${RebelColors.gold};
`
